export enum SalespersonTags {
  "MAX_VOLER" = "max-voler",
  "TEST" = "test",
}